(() => {
  const { notifyScript, notifyStyle } = document.currentScript.dataset;
  const selector = '[data-notify-toggle], [data-notify-card]';
  let loading = false;
  let style;

  const load = () => {
    if (loading) return;
    loading = true;
    if (!style) {
      style = document.createElement('link');
      style.rel = 'stylesheet';
      style.href = notifyStyle;
      document.head.appendChild(style);
    }
    const script = document.createElement('script');
    script.src = notifyScript;
    script.onload = () => observer.disconnect();
    script.onerror = () => {
      script.remove();
      loading = false;
    };
    document.head.appendChild(script);
  };

  // Recommendations, filters and the theme editor can add controls after load.
  // Inspect only added subtrees; stop observing once the bridge takes over.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) {
          load();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (document.querySelector(selector)) load();
})();
